import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/Cancel';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import { addCountryOfOrigin, deleteCountryOfOrigin, xirifyEnv, updateCountryOfOrigin, countryOfOriginList } from '../../actions/countryOfOriginAction';
import { Badge, Divider } from "@material-ui/core";
import { CSVLink } from "react-csv";
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        width: '168px'
    },
    secondaryButton: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.main,
        border: '1px solid #14B7DD',
        fontWeight: 'bold'
    },
    closeBadge: {
        color: 'grey',
        cursor: 'pointer'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '400px'
    },
    deleteBtn: {
        cursor: 'pointer',
        color: 'grey',
        margin: "0px 10px"
    },
    editBtn: {
        cursor: 'pointer',
        color: 'grey',
        margin: "0px 10px"
    },
    avatarGrey: {
        width: theme.spacing(10),
        height: theme.spacing(6),
    },
    img: {
        width: '43px',
        height: '43px',
    },
    containerTable: {
        padding: '0px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        marginTop: theme.spacing(3)
    },
    table: {
        justifyContent: 'left'
    },
    tableRow: {
        cursor: 'pointer',
        height: '60px'
    },
    tableBtn: {
        padding: '0px'
    },
    form: {
        margin: '5% 10%',
        maxWidth: '350px',
        backgroundColor: theme.palette.background.paper,
    },
    headerBar: {
        color: 'white',
        backgroundColor: theme.palette.primary.main
    },
    headGridTwoButton: {
        float: 'right',
        marginTop: '2px'
    },
    content: {
        margin: '10px 0px',
        overflow: 'auto',
    },
    footer: {
        height: '10%',
        margin: '20px 0px 10px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class CountryOfOrigin extends Component {
    constructor() {
        super();
        this.state = {
            value: 0,
            modalAddOpen: false,
            modalEditOpen: false,
            modalDeleteOpen: false,
            snackOpen: false,
            noDelMsg: null,
            sucessMsg: null,
            showExcel: false,
            errorMsg: null,
            backDropOpen: false,
            isFetching: false,
            selectedCountryOfOrigin: null,
            countryOfOriginExists: null,
            inputErrorMessage: null,
            cloudinaryData: null,
            countryOfOriginName: "",
            countryOfOriginImage: null,
            countryOfOriginData: {},
            countryOfOriginList: [],
            cloudinaryFileData: null,
            isDisabled: true,
            excelDownloadList: [],
            countryOfOriginFile: null
        };
        this.inputReference = React.createRef();
    }

    fileUploadAction = () => this.inputReference.current.click();

    componentDidMount() {
        this.props.attrs.changeHeaderName("Country of Origin");
        this.getCountryOfOriginList();
        this.getCloudinaryEnv();
    }

    getCountryOfOriginList = async () => {
        try {
            let response = await countryOfOriginList();

            if (response && response.data) {
                this.setState({ countryOfOriginList: response.data });

                let excelList = response.data.map(item => ({ name: item.name }));
                this.setState({ excelDownloadList: excelList });
            } else {
                console.error("Error: Unable to fetch country of origin list. Response or response data is undefined.");
            }
        } catch (error) {
            console.error("Error fetching country of origin list:", error);
        }
    }

    getCloudinaryEnv = async () => {
        try {
            let res = await xirifyEnv();
            if (res && res.data) {
                this.setState({ cloudinaryData: res.data });
            } else {
                console.error("Error: Unable to fetch cloudinary environment. Response or response data is undefined.");
            }
        } catch (error) {
            console.error("Error fetching cloudinary environment:", error);
        }
    }

    removeCountryOfOriginImage = (e) => {
        this.setState({ countryOfOriginFile: null });
    }

    handleChange = async (e) => {
        const { target: { value } } = e;
        if (e.target.files) {
            this.setState({ countryOfOriginImage: e.target.files[0] });
            let files = e.target.files;
            let data = new FormData();
            let folderPath = "Marketplace_Business";
            let temp = files[0].name.split(".");
            let fileName = temp[0] + Math.ceil(Math.random() * 999999) + "." + temp[1];

            data.append("file", files[0]);
            data.append("folder", folderPath);
            data.append(
                "public_id",
                `${fileName}`
            );
            data.append(
                "upload_preset",
                this.state.cloudinaryData.cloudinaryBusinessImagesUploadPreset
            );
            let res = await fetch(this.state.cloudinaryData.cloudinaryUploadUrl, {
                method: "POST",
                body: data,
            });

            let file = await res.json();
            this.setState({ countryOfOriginFile: file });

        } else {
            this.setState({ countryOfOriginName: value });
            if (!value.trim()) {
                this.setState({ inputErrorMessage: "Country of Origin Name Cannot Be Empty" });
                this.setState({ countryOfOriginName: "", isDisabled: true });
            } else {
                this.setState({ inputErrorMessage: null, isDisabled: false });
            }
        }
    }

    handleModalAddOpen = () => {
        this.setState({ modalAddOpen: true });
        this.setState({ countryOfOriginName: "" })
        this.setState({ selectedCountryOfOrigin: null });
        this.setState({ countryOfOriginImage: null, countryOfOriginFile: null });
    }

    handleModalAddClose = () => {
        this.setState({ modalAddOpen: false, inputErrorMessage: null });
        this.setState({ countryOfOriginImage: null, countryOfOriginFile: null, countryOfOriginName: '' });
    }

    handleDialogueDeleteOpen = (countryOfOriginType) => {
        this.setState({ modalDeleteOpen: true });
        this.setState({ selectedCountryOfOrigin: countryOfOriginType });
    }

    handleDialogueDeleteClose = () => {
        this.setState({ modalDeleteOpen: false });
    }

    handleEditModalOpen = (countryOfOriginType) => {
        this.setState({ selectedCountryOfOrigin: { ...countryOfOriginType } });
        this.setState({ countryOfOriginName: countryOfOriginType.name });
        this.setState({ countryOfOriginImage: (countryOfOriginType?.image?.path) ? countryOfOriginType.image.path : null });
        if (countryOfOriginType?.image?.path) {
            this.setState({ countryOfOriginFile: { secure_url: countryOfOriginType?.image?.path } });
        } else {
            this.setState({ countryOfOriginFile: null });
        }
        this.setState({ modalEditOpen: true });
    }

    handleEditModalClose = () => {
        this.setState({ modalEditOpen: false });
        this.setState({ countryOfOriginName: "" });
        this.setState({ countryOfOriginImage: null, inputErrorMessage: null });
    }

    handleEditSubmit = async (event) => {
        event.preventDefault();

        if (!this.state.countryOfOriginName) {
            this.setState({ errorMsg: "Country of Origin Name Cannot Be Empty" });
            this.setState({ snackOpen: true });
            return;
        }

        let fileUpdated = false;
        if (this.state.countryOfOriginFile && !this.state.countryOfOriginFile.error) {
            fileUpdated = true;
        }

        if (!fileUpdated) {
            this.setState({ errorMsg: "Icon is mandatory" });
            this.setState({ snackOpen: true });
            return;
        }

        for (let i = 0; i < this.state.countryOfOriginList.length; i++) {
            if (this.state.selectedCountryOfOrigin._id !== this.state.countryOfOriginList[i]._id && this.state.countryOfOriginName.trim().toLowerCase() === this.state.countryOfOriginList[i].name.trim().toLowerCase()) {
                this.setState({ inputErrorMessage: "Country of Origin With the Same Name Already Exists" });
                return;
            }
        }

        let payload = {
            _id: this.state.selectedCountryOfOrigin._id,
            name: this.state.countryOfOriginName
        };

        if (fileUpdated) {
            payload["image"] = {
                title: "countryOfOrigin",
                path: this.state.countryOfOriginFile.secure_url,
                public_id: this.state.countryOfOriginFile.public_id
            }
        } else {
            payload.image = null;
        }

        let response = await updateCountryOfOrigin(payload);

        if (response) {
            this.setState({ sucessMsg: "Updated Country of Origin Successfully" });
            this.setState({ modalEditOpen: false });
            this.getCountryOfOriginList();
        } else {
            this.setState({ errorMsg: "Error in updating the Country of Origin" });
            this.setState({ snackOpen: true });
        }
    }

    handleAddSubmit = async (event) => {
        event.preventDefault();

        this.setState({ isDisabled: true });
        if (!this.state.countryOfOriginName) {
            this.setState({ errorMsg: "Country of Origin Name Cannot Be Empty" });
            this.setState({ snackOpen: true });
            this.setState({ isDisabled: false });
            return;
        }

        if (!this.state.countryOfOriginFile && !this.state.countryOfOriginImage) {
            this.setState({ errorMsg: "Icon is mandatory" });
            this.setState({ snackOpen: true });
            this.setState({ isDisabled: false });
            return;
        }

        for (let i = 0; i < this.state.countryOfOriginList.length; i++) {
            if (this.state.countryOfOriginName.trim().toLowerCase() === this.state.countryOfOriginList[i].name.trim().toLowerCase()) {
                this.setState({ inputErrorMessage: "Country of Origin With the Same Name Already Exists" });
                return;
            }
        }

        let payload = {
            name: this.state.countryOfOriginName
        };

        if (this.state.countryOfOriginFile && !this.state.countryOfOriginFile.error) {
            payload["image"] = {
                title: "Country of Origin",
                path: this.state.countryOfOriginFile.secure_url,
                public_id: this.state.countryOfOriginFile.public_id
            }
        }

        let response = await addCountryOfOrigin(payload);

        if (response) {
            this.setState({ sucessMsg: "Added Country of Origin Successfully" });
            this.setState({ modalAddOpen: false, countryOfOriginName: '', countryOfOriginFile: null });
            this.getCountryOfOriginList();
        } else {
            this.setState({ errorMsg: "Error in Adding the Country of Origin" });
            this.setState({ snackOpen: true });
        }
    }

    handleDeleteCategory = async () => {
        let response = await deleteCountryOfOrigin(this.state.selectedCountryOfOrigin._id);
        if (response) {
            this.setState({ modalDeleteOpen: false });
            this.getCountryOfOriginList();
        }
    }

    handleSnackClose = () => {
        this.setState({ snackOpen: false });
        this.setState({ noDelMsg: null });
        this.setState({ errorMsg: null });
        this.setState({ sucessMsg: null });
    }

    showExcel = async () => {
        this.getCountryOfOriginList();
        this.setState({ showExcel: true });
    }

    render() {
        const { classes } = this.props;
        let muiAlert = null;
        let headers = [
            { label: 'Country of Origin Name', key: 'name' }
        ];

        if (this.state.sucessMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="success">
                {this.state.sucessMsg}
            </MuiAlert>
        } else if (this.state.errorMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.errorMsg}
            </MuiAlert>
        } else if (this.state.noDelMsg) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.noDelMsg}
            </MuiAlert>
        } else if (this.state.countryOfOriginExists) {
            muiAlert = <MuiAlert elevation={6} variant="filled" onClose={this.handleSnackClose} severity="error">
                {this.state.countryOfOriginExists}
            </MuiAlert>
        }

        return (
            <Container>
                <Grid container justify="space-between">
                    <Grid item style={{ paddingRight: '460px' }}>
                        <Button variant="contained" color="primary" className={classes.button} startIcon={<AddIcon />}
                            onClick={this.handleModalAddOpen}>
                            COUNTRY OF ORIGIN
                        </Button>
                    </Grid>
                    <Grid alignContent="right" >
                        {this.state.showExcel ?
                            (this.state.excelDownloadList.length > 0 ?
                                <CSVLink
                                    data={this.state.excelDownloadList}
                                    headers={headers}
                                    filename={"countriesOfOrigin.csv"}
                                    className="btn btn"
                                    target="_blank"
                                >
                                    <Tooltip title="Export to Excel">
                                        <img alt="Export To Excel" src="../../../images/exportToExcel.png" width="25" height="25" />
                                    </Tooltip>
                                </CSVLink>
                                : null)
                            :
                            <Button variant="contained" color="primary"
                                onClick={() => this.showExcel()}>
                                DOWNLOAD LIST
                            </Button>
                        }
                    </Grid>
                </Grid>
                {this.state.countryOfOriginList.length > 0 &&
                    <Container className={classes.containerTable}>
                        <TableContainer className={classes.table} component={Paper}>
                            <Table size="small" aria-label="a dense table">
                                <TableBody>
                                    {this.state.countryOfOriginList.map((countryOfOriginType, index) => {
                                        return (
                                            <TableRow className={classes.tableRow} hover key={countryOfOriginType.name}>
                                                <TableCell align="left" style={{ width: '100px' }}>
                                                    {countryOfOriginType?.image?.path &&
                                                        <img style={{ "objectFit": "contain" }} variant="square" src={countryOfOriginType?.image?.path} alt=" " className={classes.avatarGrey} />
                                                    }
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Typography color="textPrimary" variant="subtitle1" gutterBottom>
                                                        {countryOfOriginType.name}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell align="right" className={classes.tableBtn} style={{ width: '100px' }}>
                                                    <div>
                                                        <EditIcon className={classes.editBtn} onClick={() => this.handleEditModalOpen(countryOfOriginType)} />
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right" className={classes.tableBtn} style={{ width: '100px' }}>
                                                    <DeleteIcon className={classes.deleteBtn} onClick={() => this.handleDialogueDeleteOpen(countryOfOriginType)} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                }
                <Dialog
                    className={classes.modal}
                    open={this.state.modalAddOpen}
                    onClose={this.handleModalAddClose}
                    closeAfterTransition
                    fullWidth={true}
                    maxWidth={false}
                >
                    <DialogTitle className={classes.headerBar} id="form-dialog-title">
                        <div >Add Country of Origin
                            <CloseIcon className={classes.headGridTwoButton} onClick={this.handleModalAddClose} />
                        </div>
                    </DialogTitle>
                    <form className={classes.form} onSubmit={this.handleAddSubmit}>
                        <Grid container className={classes.content}>
                            <TextField
                                name="addCountryOfOrigin"
                                label="Country of Origin Name"
                                value={this.state.countryOfOriginName}
                                fullWidth variant="outlined"
                                margin="normal"
                                inputProps={{
                                    maxLength: 30,
                                }}
                                onChange={this.handleChange}
                                error={Boolean(this.state.inputErrorMessage)}
                                helperText={this.state.inputErrorMessage}
                            />

                            <Grid container style={{ margin: '20px 0px' }} alignItems="center" justify="space-around">
                                <Grid item xs={6} >
                                    {this.state.countryOfOriginFile ?
                                        <Badge className={classes.closeBadge} badgeContent={<CancelIcon onClick={this.removeCountryOfOriginImage} />}>
                                            <div className={classes.img}>
                                                <img border="0" className={classes.img} src={this.state.countryOfOriginFile.secure_url} alt="" />
                                            </div >
                                        </Badge>
                                        :
                                        <div >
                                            <Typography >
                                                No File Chosen
                                            </Typography>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={6} >
                                    <Button variant="contained" htmlFor="myInput2" style={{ float: 'right' }} onClick={this.fileUploadAction} color="primary" className={classes.secondaryButton}>
                                        {this.state.countryOfOriginFile ? 'Change Icon' : 'Add Icon'}
                                    </Button>
                                    <input
                                        ref={this.inputReference}
                                        id="myInput2"
                                        name="CountryOfOrigin"
                                        style={{ display: 'none' }}
                                        type={"file"}
                                        onChange={this.handleChange}
                                        accept="image/x-png,image/jpeg"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider></Divider>
                        <Container className={classes.footer}>
                            <div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    margin="normal"
                                    color="primary"
                                    disabled={this.state.isDisabled}
                                    onClick={this.handleAddSubmit}>
                                    Confirm
                                </Button>
                            </div>
                        </Container>
                    </form>
                </Dialog>
                <Dialog
                    className={classes.modal}
                    open={this.state.modalEditOpen}
                    onClose={this.handleEditModalClose}
                    closeAfterTransition
                    fullWidth={true}
                    maxWidth={false}
                >
                    <DialogTitle className={classes.headerBar} id="form-dialog-title">
                        <div >Edit Country of Origin
                            <CloseIcon className={classes.headGridTwoButton} onClick={this.handleEditModalClose} />
                        </div>
                    </DialogTitle>
                    <form className={classes.form} onSubmit={this.handleEditSubmit}>
                        <Grid container className={classes.content}>
                            <TextField
                                name="editCountryOfOrigin"
                                label="Country of Origin Name"
                                value={this.state.countryOfOriginName}
                                fullWidth variant="outlined"
                                margin="normal"
                                inputProps={{
                                    maxLength: 30,
                                }}
                                onChange={this.handleChange}
                                error={Boolean(this.state.inputErrorMessage)}
                                helperText={this.state.inputErrorMessage}
                            />
                            <Grid container style={{ margin: '20px 0px' }} alignItems="center" justify="space-around">
                                <Grid item xs={6} >
                                    {this.state.countryOfOriginFile ?
                                        <Badge className={classes.closeBadge} badgeContent={<CancelIcon onClick={this.removeCountryOfOriginImage} />}>
                                            <div className={classes.img}>
                                                <img border="0" className={classes.img} src={this.state.countryOfOriginFile.secure_url} alt="" />
                                            </div >
                                        </Badge>
                                        :
                                        <div >
                                            <Typography >
                                                No File Chosen
                                            </Typography>
                                        </div>
                                    }
                                </Grid>
                                <Grid item xs={6} >
                                    <Button variant="contained" htmlFor="myInput2" style={{ float: 'right' }} onClick={this.fileUploadAction} color="primary" className={classes.secondaryButton}>
                                        {this.state.countryOfOriginFile ? 'Change Icon' : 'Add Icon'}
                                    </Button>
                                    <input
                                        ref={this.inputReference}
                                        id="myInput2"
                                        name="CountryOfOrigin"
                                        style={{ display: 'none' }}
                                        type={"file"}
                                        onChange={this.handleChange}
                                        accept="image/x-png,image/jpeg"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider></Divider>
                        <Container className={classes.footer}>
                            <div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    margin="normal"
                                    color="primary"
                                    onClick={this.handleEditSubmit}>
                                    Confirm
                                </Button>
                            </div>
                        </Container>
                    </form>
                </Dialog>
                <Dialog
                    open={this.state.modalDeleteOpen}
                    onClose={this.handleDialogueDeleteClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Do you want to delete the country of origin?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={this.handleDialogueDeleteClose} className={classes.secondaryButton}>
                            No
                        </Button>
                        <Button variant="contained" onClick={this.handleDeleteCategory} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.snackOpen}
                    autoHideDuration={6000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}>
                    {muiAlert}
                </Snackbar>

            </Container >
        )
    }
}

export default (withStyles(styles)(CountryOfOrigin));

